(() => {
  const loginAndRegisterMain = document.getElementById("loginAndRegisterMain");
  const priceVariantB = document.getElementById('PriceVariantB')
  if (!loginAndRegisterMain) return;
  try {
    const locationPath = location.pathname.replace('/pages/latest', '').split('/');
    const country = locationPath[1];
    const lang = locationPath[2];
    if (!window.sessionStorage.getItem('AccountNumber')) {
      [{ hostname: window.location.hostname, domain: false },
      { hostname: '.westernunion.com', domain: true }
      ].forEach(({ hostname, domain }) => {
        CookieService.deleteCookie('SessionInfoRetail', '/', hostname, domain);
        CookieService.deleteCookie('SessionInfo', '/', hostname, domain);
        CookieService.deleteCookie('SessionIdRetail', '/', hostname, domain);
        CookieService.deleteCookie('SessionDomainRetail', '/', hostname, domain);
        CookieService.deleteCookie('SessionDomain', '/', hostname, domain);
        CookieService.deleteCookie('sessionTimer', '/', hostname, domain);
        CookieService.deleteCookie('SessionId', '/', hostname, domain);
        CookieService.deleteCookie('EncryptedSessionId', `/${country}/${lang}`, hostname, domain);
        CookieService.deleteCookie('EncryptedSessionId', `/`, hostname, domain);
        CookieService.deleteCookie('LangCode', '/', hostname, domain);
        CookieService.deleteCookie('UserID', '/', hostname, domain);
        CookieService.deleteCookie('NewUserCookie', '/', hostname, domain);
        CookieService.deleteCookie('loggedIn', '/', hostname, domain);
        CookieService.deleteCookie('CountryCode', '/', hostname, domain);
        CookieService.deleteCookie('userType', '/', hostname, domain);
        CookieService.deleteCookie('UserLocale', '/', hostname, domain);
      })
      window.sessionStorage.clear();
    }
    const isR4triggerAPI = CookieService.getCookie('triggerAPI') === 'R4';
    const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const passwordFormat = /((?=.*[a-z])(?=.*[A-Z])(?=.*[0123456789])^.{8,16}$)/;
    let signupEmailErrorText = loginAndRegisterMain.querySelector('.signupEmailId-error');
    let passwordErrorText = loginAndRegisterMain.querySelector('.signupPassword-error');
    let signupEmailId = loginAndRegisterMain.querySelector("#signupEmailId");
    let signupPassword = loginAndRegisterMain.querySelector("#signupPassword");
    const btnTriggerAddCustomerApi = loginAndRegisterMain.querySelector("#btnTriggerAddCustomerApi");
    const btnTriggerSignInApi = loginAndRegisterMain.querySelector("#btnTriggerSignInApi");

    const joinNowCTA = priceVariantB?.querySelector('.receiver_join_now_cta');

    const spinnerContainer = document.getElementById('spinnerContainer');

    const inputLabels = loginAndRegisterMain.querySelectorAll('.input-label')
    Array.from(inputLabels).forEach((el) => {
      let labelEl = el.querySelector('label')
      let inputEL = el.querySelector('input')
      labelEl.addEventListener('click', () => {
        inputEL.focus()
      })
    })

    signupEmailErrorText = signupEmailErrorText && signupEmailErrorText.innerText?.trim();
    passwordErrorText = passwordErrorText && passwordErrorText.innerText?.trim();

    let sessionData = null;

    const onKeyPressEventOfInputFields = (event) => {
      let elementId = event.currentTarget.id;
      let elementObject = document.getElementById(elementId);
      hideValidationMessage(elementObject);
    }

    const triggerEmailValidation = (emailAddressEL) => {
      if (emailAddressEL) {
        hideValidationMessage(emailAddressEL);
        let emailAddress = emailAddressEL.value;
        if (emailAddress !== undefined) {
          if (emailAddress == "") {
            showValidationMessage(emailAddressEL, signupEmailErrorText);
            emailAddressEL.focus();
            return false;
          } else if (!emailAddress.match(mailformat)) {
            showValidationMessage(emailAddressEL, signupEmailErrorText);
            emailAddressEL.focus();
            return false;
          } else {
            return true;
          }
        }
      }
    }

    const triggerPasswordValidation = (passwordEL) => {
      if (passwordEL) {
        hideValidationMessage(passwordEL);
        let passwd = passwordEL.value;
        if (passwd !== undefined) {
          if (passwd == "") {
            showValidationMessage(passwordEL, passwordErrorText);
            passwordEL.focus();
            return false;
          } else if (!passwd.match(passwordFormat)) {
            showValidationMessage(passwordEL, passwordErrorText);
            passwordEL.focus();
            return false;
          } else {
            return true;
          }
        }
      }
    }

    const hideSpinner = () => {
      spinnerContainer && toggleClass && toggleClass(spinnerContainer, 'd-flex', 'd-none')
    }

    const showSpinner = () => {
      spinnerContainer && toggleClass && toggleClass(spinnerContainer, 'd-none', 'd-flex')
    }

    const getJoinNowCTAParams = () => {
      if (!joinNowCTA) {
        return '';
      }

      const url = joinNowCTA.getAttribute('href');
      if (!url || url == '#') {
        return '';
      }

      return url.split('?')[1];
    };

    const getCountryText = () => {
      const countryNameEl = document.querySelector("#footer-country-dropdown .b-flag-select__value");
      return (countryNameEl && countryNameEl.innerText) ?? '';
    };

    if (signupEmailId.value) {
      signupEmailId.setAttribute('value', signupEmailId.value)
    }
    if (signupPassword.value) {
      signupPassword.setAttribute('value', signupPassword.value)
    }

    signupEmailId.addEventListener("keypress", onKeyPressEventOfInputFields);
    signupPassword.addEventListener("keypress", onKeyPressEventOfInputFields);

    [signupEmailId, signupPassword].forEach((el) => {
      el.addEventListener('input', (event) => {
        event.target.setAttribute("value", event.target.value)
      })
    })

    /* ---------------- SIGN UP ------------------- */
    const showSignUpR4ValidationApiError = (error, message) => {
      const messageLowerCase = message?.toLowerCase()
      if (messageLowerCase?.indexOf('email') !== -1) {
        showValidationMessage(signupEmailId, message)
      } else if (messageLowerCase?.indexOf('password') !== -1) {
        showValidationMessage(signupPassword, message)
      } else if (messageLowerCase) {
        showValidationMessage(signupEmailId, message)
      } else {
        showValidationMessage(signupEmailId, error?.error?.message)
      }
    };

    const showSignUpR3ValidationApiError = (error) => {
      if (error?.error?.code === 'C1035') {
        showValidationMessage(signupPassword, error?.error?.message)
      } else {
        showValidationMessage(signupEmailId, error?.error?.message)
      }
    };

    const showSignUpValidationApiError = (error, message, isR4 = false) => {
      if (isR4) {
        showSignUpR4ValidationApiError(error, message);
        return;
      }

      showSignUpR3ValidationApiError(error);
    }

    btnTriggerAddCustomerApi &&
      btnTriggerAddCustomerApi.addEventListener("click", function () {
        sessionData = null;
        const userData = {};

        signupEmailId.value = signupEmailId.value?.trim();
        userData.emailId = signupEmailId.value?.trim();
        userData.password = signupPassword.value;

        const isEmailValid = triggerEmailValidation(signupEmailId);
        const isPasswordValid = triggerPasswordValidation(signupPassword);

        if (!isEmailValid || !isPasswordValid) {
          return;
        }

        btnTriggerAddCustomerApi.setAttribute('disabled', 'disabled');
        showSpinner();

        const countryText = getCountryText();
        SignUpService.signUp(country, countryText, lang, location.host, userData, false)
          .then((signUpResponse) => {
            if (signUpResponse.urlType) {
              const joinNowCTAParams = getJoinNowCTAParams();
              const redirectionUrl = URLService.get(signUpResponse.urlType, country, lang, joinNowCTAParams);

              if (redirectionUrl) {
                location.href = redirectionUrl;
                return;
              }
            }

            if (signUpResponse.error) {
              showSignUpValidationApiError(signUpResponse.error, signUpResponse.message,false);
              return;
            }
          })
          .catch((error) => {
            showSignUpValidationApiError(error)
          })
          .finally(() => {
            btnTriggerAddCustomerApi.removeAttribute('disabled');
            hideSpinner();
          });
      });
    /* ---------------- SIGN UP ------------------- */

    /* ---------------- SIGN IN ------------------- */
    const showSignInValidationApiError = (error, message) => {
      const messageLowerCase = message?.toLowerCase()
      if (messageLowerCase?.indexOf('email') !== -1) {
        showValidationMessage(signupEmailId, message)
      } else if (messageLowerCase?.indexOf('password') !== -1) {
        showValidationMessage(signupPassword, message)
      } else if (messageLowerCase) {
        showValidationMessage(signupEmailId, message)
      } else {
        showValidationMessage(signupEmailId, error?.error?.message)
      }
    }

    btnTriggerSignInApi &&
      btnTriggerSignInApi.addEventListener("click", function () {
        const userData = {};

        signupEmailId.value = signupEmailId.value?.trim();
        userData.emailId = signupEmailId.value?.trim();
        userData.password = signupPassword.value;

        const isEmailValid = triggerEmailValidation(signupEmailId);
        const isPasswordValid = triggerPasswordValidation(signupPassword);

        if (!isEmailValid || !isPasswordValid) {
          return;
        }

        btnTriggerSignInApi.setAttribute('disabled', 'disabled');
        showSpinner();

        const countryText = getCountryText();
        SignInService.signIn(country, countryText, lang, location.host, userData, isR4triggerAPI)
          .then((signInResponse) => {
            if (signInResponse.urlType) {
              const joinNowCTAParams = getJoinNowCTAParams();
              const redirectionUrl = URLService.get(signInResponse.urlType, country, lang, joinNowCTAParams);

              if (redirectionUrl) {
                location.href = redirectionUrl;
                return;
              }
            }

            if (signInResponse.error) {
              showSignInValidationApiError(signInResponse.error, signInResponse.message);
              return;
            }
          })
          .catch((error) => {
            showSignInValidationApiError(error)
          })
          .finally(() => {
            btnTriggerSignInApi.removeAttribute('disabled');
            hideSpinner();
          });
      });
    /* ---------------- SIGN IN ------------------- */
  } catch (e) {
    // Error handled silently for security
  }
})()
